import { Box, Button, Image, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../../content/Content";
import Slider from "react-slick";
import "./calender.component.css";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
const Calender = () => {
  const CalenderData = [
    {
      avatar: Img.avatar1,
      name: "Kimbrealy Tories",
      sun: false,
      mon: false,
      tue: true,
      wed: false,
      thu: false,
      fri: false,
      sat: false,
      timeSet1: "Live Analyst 7:00 AM EDT",
      timeSet2: "Live Analyst 10:00 AM EDT",
      bgColor: "rgba(96, 31, 235, 1)",
      bgColor2: "",
    },
    {
      avatar: Img.avatar2,
      name: "Kimbrealy Tories ",
      sun: true,
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
      sat: false,
      timeSet1: "Live Analyst 7:00 AM EDT",
      timeSet2: "Live Analyst 10:00 AM EDT",
      bgColor: "rgba(96, 31, 235, 1)",
      bgColor2: "",
    },

    {
      avatar: Img.avatar3,
      name: "Cameron Williamson",
      sun: false,
      mon: false,
      tue: false,
      wed: true,
      thu: false,
      fri: false,
      sat: false,
      timeSet1: "Live Analyst 7:00 AM EDT",
      timeSet2: "Live Analyst 10:00 AM EDT",
      bgColor: "rgba(96, 31, 235, 1)",
      bgColor2: "",
    },

    {
      avatar: Img.avatar4,
      name: "Devon Lane",
      sun: false,
      mon: true,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
      sat: false,
      timeSet1: "Live Analyst 7:00 AM EDT",
      timeSet2: "Live Analyst 10:00 AM EDT",
      bgColor: "rgba(96, 31, 235, 1)",
      bgColor2: "",
    },
    {
      avatar: Img.avatar5,
      name: "Eleanor Pena",
      sun: false,
      mon: false,
      tue: false,
      wed: true,
      thu: true,
      fri: false,
      sat: false,
      timeSet1: "Live Analyst 7:00 AM EDT",
      timeSet2: "Live Analyst 10:00 AM EDT",
      bgColor: "rgba(96, 31, 235, 1)",
      bgColor2: "",
    },

    {
      avatar: Img.avatar6,
      name: "Wade Warren",
      sun: false,
      mon: false,
      tue: false,
      wed: true,
      thu: false,
      fri: true,
      sat: false,
      timeSet1: "Live Analyst 7:00 AM EDT",
      timeSet2: "Live Analyst 10:00 AM EDT",
      bgColor: "rgba(96, 31, 235, 1)",
      bgColor2: "rgba(149, 151, 171, 1)",
    },
    {
      avatar: Img.avatar7,
      name: "Devon Lane",
      sun: true,
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
      sat: false,
      timeSet1: "Live Analyst 7:00 AM EDT",
      timeSet2: "Live Analyst 10:00 AM EDT",
      bgColor: "rgba(96, 31, 235, 1)",
      bgColor2: "",
    },
    {
      avatar: Img.avatar8,
      name: "Wade Warren",
      sun: false,
      mon: false,
      tue: true,
      wed: false,
      thu: false,
      fri: false,
      sat: false,
      timeSet1: "Live Analyst 7:00 AM EDT",
      timeSet2: "Live Analyst 10:00 AM EDT",
      bgColor: "rgba(149, 151, 171, 1)",
      bgColor2: "",
    },
    {
      avatar: Img.avatar9,
      name: "Cameron Williamson",
      sun: false,
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: true,
      sat: false,
      timeSet1: "Live Analyst 7:00 AM EDT",
      timeSet2: "Live Analyst 10:00 AM EDT",
      bgColor: "rgba(96, 31, 235, 1)",
      bgColor2: "",
    },
    {
      avatar: Img.avatar10,
      name: "Savannah Nguyen",
      sun: false,
      mon: false,
      tue: false,
      wed: true,
      thu: false,
      fri: false,
      sat: false,
      timeSet1: "Live Analyst 7:00 AM EDT",
      timeSet2: "Live Analyst 10:00 AM EDT",
      bgColor: "rgba(96, 31, 235, 1)",
      bgColor2: "",
    },
  ];
  const CalenderDataMobile = [
    {
      avatar: Img.avatar1,
      name: "Kimbrealy Tories",
      sun: false,
      mon: false,
      tue: true,
      wed: false,
      thu: false,
      fri: false,
      sat: false,
      timeSet1: "Live Analyst ",
      timeSet2: "Live Analyst ",
      time1: "7:00 AM EDT",
      time2: "10:00 AM EDT",
      bgColor: "rgba(96, 31, 235, 1)",
      bgColor2: "",
      // avatar 2 in here

      avatar2: Img.avatar2,
      name2: "Kimbrealy Tories ",
      sun2: true,
      mon2: false,
      tue2: false,
      wed2: false,
      thu2: false,
      fri2: false,
      sat2: false,
      timeSet3: "Live Analyst",
      timeSet4: "Live Analyst",
      time3: "7:00 AM EDT",
      time4: "10:00 AM EDT",
      bgColor3: "rgba(96, 31, 235, 1)",
      bgColor4: "",
    },
    {
      avatar: Img.avatar3,
      name: "Cameron Williamson",
      sun: false,
      mon: false,
      tue: false,
      wed: true,
      thu: false,
      fri: false,
      sat: false,
      timeSet1: "Live Analyst ",
      timeSet2: "Live Analyst ",
      bgColor: "rgba(96, 31, 235, 1)",
      bgColor2: "",
      // avater 2

      avatar2: Img.avatar4,
      name2: "Devon Lane",
      sun2: false,
      mon2: true,
      tue2: false,
      wed2: false,
      thu2: false,
      fri2: false,
      sat2: false,
      timeSet3: "Live Analyst ",
      timeSet4: "Live Analyst ",
      bgColor3: "rgba(96, 31, 235, 1)",
      bgColor4: "",
    },
    {
      avatar: Img.avatar5,
      name: "Eleanor Pena",
      sun: false,
      mon: false,
      tue: false,
      wed: true,
      thu: true,
      fri: false,
      sat: false,
      timeSet1: "Live Analyst",
      timeSet2: "Live Analyst",
      time1: "7:00 AM EDT",
      time2: "10:00 AM EDT",
      bgColor: "rgba(96, 31, 235, 1)",
      bgColor2: "",

      // avater 2

      avatar2: Img.avatar6,
      name2: "Wade Warren",
      sun2: false,
      mon2: false,
      tue2: false,
      wed2: true,
      thu2: false,
      fri2: true,
      sat2: false,
      timeSet3: "Live Analyst",
      timeSet4: "Live Analyst",
      bgColor3: "rgba(96, 31, 235, 1)",
      bgColor4: "rgba(149, 151, 171, 1)",
    },
    {
      avatar: Img.avatar7,
      name: "Devon Lane",
      sun: true,
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
      sat: false,
      timeSet1: "Live Analyst ",
      timeSet2: "Live Analyst ",
      bgColor: "rgba(96, 31, 235, 1)",
      bgColor2: "",
      time1: "7:00 AM EDT",
      time2: "10:00 AM EDT",
      // avatr 2

      avatar2: Img.avatar8,
      name2: "Wade Warren",
      sun2: false,
      mon2: false,
      tue2: true,
      wed2: false,
      thu2: false,
      fri2: false,
      sat2: false,
      timeSet3: "Live Analyst",
      timeSet4: "Live Analyst ",
      bgColor3: "rgba(149, 151, 171, 1)",
      bgColor4: "",
    },
    {
      avatar: Img.avatar9,
      name: "Cameron Williamson",
      sun: false,
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: true,
      sat: false,
      timeSet1: "Live Analyst ",
      timeSet2: "Live Analyst",
      bgColor: "rgba(96, 31, 235, 1)",
      bgColor2: "",
      time1: "7:00 AM EDT",
      time2: "10:00 AM EDT",
      // avatar
      avatar2: Img.avatar10,
      name2: "Savannah Nguyen",
      sun2: false,
      mon2: false,
      tue2: false,
      wed2: true,
      thu2: false,
      fri2: false,
      sat2: false,
      timeSet3: "Live Analyst",
      timeSet4: "Live Analyst",
      bgColor3: "rgba(96, 31, 235, 1)",
      bgColor4: "",
    },
  ];
  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    nav: false,
  };
  const slider = React.useRef(null);
  return (
    <VStack py="50px" w="100%">
      {/* desktop-version */}
      <Stack
        w="100%"
        borderRadius="39px"
        bg="rgba(255, 255, 255, 1)"
        p={"15px"}
        className="desktop-version"
      >
        {/* Header */}
        <Stack
          bg="rgba(245, 245, 255, 1)"
          borderRadius="11px"
          flexDir={"row"}
          alignItems={"center"}
          justifyContent={"flex-start"}
          h="64px"
        >
          <Box
            className="title"
            w="20%"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Text textAlign={"center"}>Educators/FRX Translator</Text>
          </Box>
          <Box
            className="day"
            w="11.42%"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Text>SUN</Text>
          </Box>
          <Box
            className="day"
            w="11.42%"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Text>MON</Text>
          </Box>
          <Box
            className="day"
            w="11.42%"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Text>TUE</Text>
          </Box>
          <Box
            className="day"
            w="11.42%"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Text>WED</Text>
          </Box>
          <Box
            className="day"
            w="11.42%"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Text>THU</Text>
          </Box>
          <Box
            className="day"
            w="11.42%"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Text>FRI</Text>
          </Box>
          <Box
            className="day"
            w="11.42%"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Text>SAT</Text>
          </Box>
        </Stack>

        {CalenderData.map((item) => (
          <Stack
            bg="#fbf9ff"
            borderRadius="11px"
            flexDir={"row"}
            alignItems={"center"}
            justifyContent={"flex-start"}
            gap="0"
            marginY="5px"
          >
            <Box
              className="title"
              w="20%"
              textAlign={"center"}
              borderRight="1px solid rgba(216, 216, 255, 1)"
              h="113px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Box
                h="66px"
                width={"66px"}
                marginLeft="10px"
                display="flex"
                alignItems={"center"}
              >
                <Image
                  src={item.avatar}
                  alt="avatar"
                  h="60px"
                  width={"60px"}
                  mx="auto"
                />
              </Box>

              <Text
                textAlign={"left"}
                w="70%"
                pl
                wordBreak="break-word"
                paddingLeft="14px"
                color="rgba(0, 0, 0, 1)"
                fontWeight={"500"}
                fontSize={"20px"}
              >
                {item.name}
              </Text>
            </Box>
            <Box
              className="day"
              w="11.42%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              p="0"
              m="0"
              gap="0"
              h="114px"
              borderRight="1px solid rgba(216, 216, 255, 1)"
            >
              {item.sun === true ? (
                <Box
                  bg={item.bgColor2 === "" ? item.bgColor : item.bgColor2}
                  w="100%"
                  h="114px"
                  borderRadius={"10px"}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column"
                >
                  <Text textAlign={"center"} p={"2px"} color={"#fff"}>
                    {item.timeSet1}
                  </Text>
                  <Text textAlign={"center"} p={"2px"} color={"#fff"}>
                    {item.timeSet2}
                  </Text>
                </Box>
              ) : (
                ""
              )}
            </Box>
            <Box
              className="day"
              w="11.42%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRight="1px solid rgba(216, 216, 255, 1)"
              h="114px"
            >
              {item.mon === true ? (
                <Box
                  bg={item.bgColor2 === "" ? item.bgColor : item.bgColor2}
                  w="100%"
                  h="114px"
                  borderRadius={"10px"}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column"
                >
                  <Text textAlign={"center"} p={"2px"} color={"#fff"}>
                    {item.timeSet1}
                  </Text>
                  <Text textAlign={"center"} p={"2px"} color={"#fff"}>
                    {item.timeSet2}
                  </Text>
                </Box>
              ) : (
                ""
              )}
            </Box>
            <Box
              className="day"
              w="11.42%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRight="1px solid rgba(216, 216, 255, 1)"
              h="114px"
            >
              {item.tue === true ? (
                <Box
                  bg={item.bgColor2 === "" ? item.bgColor : item.bgColor2}
                  w="100%"
                  h="114px"
                  borderRadius={"10px"}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column"
                >
                  <Text textAlign={"center"} p={"2px"} color={"#fff"}>
                    {item.timeSet1}
                  </Text>
                  <Text textAlign={"center"} p={"2px"} color={"#fff"}>
                    {item.timeSet2}
                  </Text>
                </Box>
              ) : (
                ""
              )}
            </Box>
            <Box
              className="day"
              w="11.42%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRight="1px solid rgba(216, 216, 255, 1)"
              h="114px"
            >
              {item.wed === true ? (
                <Box
                  bg={item.bgColor2 === "" ? item.bgColor : item.bgColor2}
                  w="100%"
                  h="114px"
                  borderRadius={"10px"}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column"
                >
                  <Text textAlign={"center"} p={"2px"} color={"#fff"}>
                    {item.timeSet1}
                  </Text>
                  <Text textAlign={"center"} p={"2px"} color={"#fff"}>
                    {item.timeSet2}
                  </Text>
                </Box>
              ) : (
                ""
              )}
            </Box>
            <Box
              className="day"
              w="11.42%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRight="1px solid rgba(216, 216, 255, 1)"
              h="114px"
            >
              {item.thu === true ? (
                <Box
                  bg="rgba(96, 31, 235, 1)"
                  w="100%"
                  h="114px"
                  borderRadius={"10px"}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column"
                >
                  <Text textAlign={"center"} p={"2px"} color={"#fff"}>
                    {item.timeSet1}
                  </Text>
                  <Text textAlign={"center"} p={"2px"} color={"#fff"}>
                    {item.timeSet2}
                  </Text>
                </Box>
              ) : (
                ""
              )}
            </Box>
            <Box
              className="day"
              w="11.42%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRight="1px solid rgba(216, 216, 255, 1)"
              h="114px"
            >
              {item.fri === true ? (
                <Box
                  bg="rgba(96, 31, 235, 1)"
                  w="100%"
                  h="114px"
                  borderRadius={"10px"}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column"
                >
                  <Text textAlign={"center"} p={"2px"} color={"#fff"}>
                    {item.timeSet1}
                  </Text>
                  <Text textAlign={"center"} p={"2px"} color={"#fff"}>
                    {item.timeSet2}
                  </Text>
                </Box>
              ) : (
                ""
              )}
            </Box>
            <Box
              className="day"
              w="11.42%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRight="1px solid rgba(216, 216, 255, 1)"
              h="114px"
            >
              {item.sat === true ? (
                <Box
                  bg="rgba(96, 31, 235, 1)"
                  w="100%"
                  h="114px"
                  borderRadius={"10px"}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column"
                >
                  <Text textAlign={"center"} p={"2px"} color={"#fff"}>
                    {item.timeSet1}
                  </Text>
                  <Text textAlign={"center"} p={"2px"} color={"#fff"}>
                    {item.timeSet2}
                  </Text>
                </Box>
              ) : (
                ""
              )}
            </Box>
          </Stack>
        ))}
      </Stack>
      {/* mobile-version */}
      <Stack w="100%" className="mobile-version">
        {/* Header */}
        <Stack
          flexDir="row"
          py="10px"
          justifyContent={"space-between"}
          alignItems="center"
        >
          <Button
            p="0"
            bg="transparent"
            _hover={{ bg: "transparent" }}
            onClick={() => slider?.current?.slickPrev()}
          >
            <AiOutlineArrowLeft className="left-btn" /> Prev
          </Button>
          <Button
            p="0"
            bg="transparent"
            _hover={{ bg: "transparent" }}
            onClick={() => slider?.current?.slickNext()}
          >
            Next <AiOutlineArrowRight className="right-btn" />
          </Button>
        </Stack>
        <Slider {...settings} ref={slider}>
          {CalenderDataMobile.map((item) => (
            <Stack w="100%">
              {/* top line */}
              <Stack flexDir={"row"} bg={"#fff"} borderRadius="5px">
                <Box
                  className="title"
                  w="33%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text
                    textAlign={"center"}
                    color="rgba(0, 0, 0, 1)"
                    fontSize="14px"
                    fontWeight={"500"}
                    fontFamily={"'Roboto', sans-serif"}
                  >
                    Educators/FRX Translator
                  </Text>
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Box
                    h="66px"
                    display="flex"
                    alignItems={"center"}
                    pl="14px"
                    ps="10px"
                  >
                    <Image
                      src={item.avatar}
                      alt="avatar"
                      h="34px"
                      width={"34px"}
                      mx="auto"
                    />
                  </Box>
                  <Text
                    textAlign={"left"}
                    wordBreak="break-word"
                    color="rgba(0, 0, 0, 1)"
                    fontSize="12px"
                    fontWeight={"500"}
                    fontFamily={"'Roboto', sans-serif"}
                    pl="5px"
                  >
                    {item.name}
                  </Text>
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Box h="66px" display="flex" alignItems={"center"} px="5px">
                    <Image
                      src={item.avatar2}
                      alt="avatar"
                      h="34px"
                      width={"34px"}
                      mx="auto"
                    />
                  </Box>
                  <Text
                    textAlign={"left"}
                    wordBreak="break-word"
                    color="rgba(0, 0, 0, 1)"
                    fontSize="12px"
                    fontWeight={"500"}
                    fontFamily={"'Roboto', sans-serif"}
                  >
                    {item.name2}
                  </Text>
                </Box>
              </Stack>
              {/* sun line */}
              <Stack flexDir={"row"} bg={"#fff"} borderRadius="5px" my="10px">
                <Box
                  className="title"
                  w="33%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text
                    textAlign={"center"}
                    color="rgba(0, 0, 0, 1)"
                    fontSize="14px"
                    fontWeight={"500"}
                    fontFamily={"'Roboto', sans-serif"}
                    textTransform={"capitalize"}
                  >
                    Sun
                  </Text>
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.sun === true ? (
                    <Box
                      bg={item.bgColor2 === "" ? item.bgColor : item.bgColor2}
                      w="100%"
                      h="100px"
                      borderRadius={"10px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet1} <br />
                        {item.time1}
                      </Text>
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet2} <br />
                        {item.time2}
                      </Text>
                    </Box>
                  ) : (
                    <Box h="100px" w="100%"></Box>
                  )}
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.sun2 === true ? (
                    <Box
                      bg={item.bgColor4 === "" ? item.bgColor3 : item.bgColor4}
                      w="100%"
                      h="100px"
                      borderRadius={"10px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Text
                        textAlign={"center"}
                        p={"10px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                      >
                        {item.timeSet3} <br />
                        {item.time1}
                      </Text>
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                      >
                        {item.timeSet4} <br />
                        {item.time2}
                      </Text>
                    </Box>
                  ) : (
                    ""
                  )}
                </Box>
              </Stack>
              {/* mon line */}
              <Stack flexDir={"row"} bg={"#fff"} borderRadius="5px" my="10px">
                <Box
                  className="title"
                  w="33%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text
                    textAlign={"center"}
                    color="rgba(0, 0, 0, 1)"
                    fontSize="14px"
                    fontWeight={"500"}
                    fontFamily={"'Roboto', sans-serif"}
                    w="100%"
                    textTransform={"capitalize"}
                  >
                    Mon
                  </Text>
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.mon === true ? (
                    <Box
                      bg={item.bgColor2 === "" ? item.bgColor : item.bgColor2}
                      w="100%"
                      h="100px"
                      borderRadius={"10px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet1} <br />
                        {item.time1}
                      </Text>
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet2} <br />
                        {item.time2}
                      </Text>
                    </Box>
                  ) : (
                    <Box h="100px" w="100%"></Box>
                  )}
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.mon2 === true ? (
                    <Box
                      bg={item.bgColor4 === "" ? item.bgColor3 : item.bgColor4}
                      w="100%"
                      h="100px"
                      borderRadius={"10px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Text
                        textAlign={"center"}
                        p={"10px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet3} <br />
                        {item.time1}
                      </Text>
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet4} <br />
                        {item.time2}
                      </Text>
                    </Box>
                  ) : (
                    <Box h="100px" w="100%"></Box>
                  )}
                </Box>
              </Stack>
              {/* tue line */}
              <Stack flexDir={"row"} bg={"#fff"} borderRadius="5px" my="10px">
                <Box
                  className="title"
                  w="33%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text
                    textAlign={"center"}
                    color="rgba(0, 0, 0, 1)"
                    fontSize="14px"
                    fontWeight={"500"}
                    fontFamily={"'Roboto', sans-serif"}
                    w="100%"
                    textTransform={"capitalize"}
                  >
                    Tue
                  </Text>
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.tue === true ? (
                    <Box
                      bg={item.bgColor2 === "" ? item.bgColor : item.bgColor2}
                      w="100%"
                      h="100px"
                      borderRadius={"10px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet1} <br />
                        {item.time1}
                      </Text>
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet2} <br />
                        {item.time2}
                      </Text>
                    </Box>
                  ) : (
                    <Box h="100px" w="100%"></Box>
                  )}
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.tue2 === true ? (
                    <Box
                      bg={item.bgColor4 === "" ? item.bgColor3 : item.bgColor4}
                      w="100%"
                      h="100px"
                      borderRadius={"10px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Text
                        textAlign={"center"}
                        p={"10px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet3} <br />
                        {item.time1}
                      </Text>
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet4} <br />
                        {item.time2}
                      </Text>
                    </Box>
                  ) : (
                    <Box h="100px" w="100%"></Box>
                  )}
                </Box>
              </Stack>
              {/* wed line */}
              <Stack flexDir={"row"} bg={"#fff"} borderRadius="5px" my="10px">
                <Box
                  className="title"
                  w="33%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text
                    textAlign={"center"}
                    color="rgba(0, 0, 0, 1)"
                    fontSize="14px"
                    fontWeight={"500"}
                    fontFamily={"'Roboto', sans-serif"}
                    w="100%"
                    textTransform={"capitalize"}
                  >
                    Wed
                  </Text>
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.tue === true ? (
                    <Box
                      bg={item.bgColor2 === "" ? item.bgColor : item.bgColor2}
                      w="100%"
                      h="100px"
                      borderRadius={"10px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet1} <br />
                        {item.time1}
                      </Text>
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet2} <br />
                        {item.time2}
                      </Text>
                    </Box>
                  ) : (
                    <Box h="100px" w="100%"></Box>
                  )}
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.wed2 === true ? (
                    <Box
                      bg={item.bgColor4 === "" ? item.bgColor3 : item.bgColor4}
                      w="100%"
                      h="100px"
                      borderRadius={"10px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Text
                        textAlign={"center"}
                        p={"10px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet3} <br />
                        {item.time1}
                      </Text>
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet4} <br />
                        {item.time2}
                      </Text>
                    </Box>
                  ) : (
                    <Box h="100px" w="100%"></Box>
                  )}
                </Box>
              </Stack>

              {/* thu line */}
              <Stack flexDir={"row"} bg={"#fff"} borderRadius="5px" my="10px">
                <Box
                  className="title"
                  w="33%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text
                    textAlign={"center"}
                    color="rgba(0, 0, 0, 1)"
                    fontSize="14px"
                    fontWeight={"500"}
                    fontFamily={"'Roboto', sans-serif"}
                    w="100%"
                    textTransform={"capitalize"}
                  >
                    thu
                  </Text>
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.thu === true ? (
                    <Box
                      bg={item.bgColor2 === "" ? item.bgColor : item.bgColor2}
                      w="100%"
                      h="100px"
                      borderRadius={"10px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet1} <br />
                        {item.time1}
                      </Text>
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet2} <br />
                        {item.time2}
                      </Text>
                    </Box>
                  ) : (
                    <Box h="100px" w="100%"></Box>
                  )}
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.thu2 === true ? (
                    <Box
                      bg={item.bgColor4 === "" ? item.bgColor3 : item.bgColor4}
                      w="100%"
                      h="100px"
                      borderRadius={"10px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Text
                        textAlign={"center"}
                        p={"10px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet3} <br />
                        {item.time1}
                      </Text>
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet4} <br />
                        {item.time2}
                      </Text>
                    </Box>
                  ) : (
                    <Box h="100px" w="100%"></Box>
                  )}
                </Box>
              </Stack>
              {/* fri line */}
              <Stack flexDir={"row"} bg={"#fff"} borderRadius="5px" my="10px">
                <Box
                  className="title"
                  w="33%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text
                    textAlign={"center"}
                    color="rgba(0, 0, 0, 1)"
                    fontSize="14px"
                    fontWeight={"500"}
                    fontFamily={"'Roboto', sans-serif"}
                    w="100%"
                    textTransform={"capitalize"}
                  >
                    fri
                  </Text>
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.fri === true ? (
                    <Box
                      bg={item.bgColor2 === "" ? item.bgColor : item.bgColor2}
                      w="100%"
                      h="100px"
                      borderRadius={"10px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet1} <br />
                        {item.time1}
                      </Text>
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet2} <br />
                        {item.time2}
                      </Text>
                    </Box>
                  ) : (
                    <Box h="100px" w="100%"></Box>
                  )}
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.fri2 === true ? (
                    <Box
                      bg={item.bgColor4 === "" ? item.bgColor3 : item.bgColor4}
                      w="100%"
                      h="100px"
                      borderRadius={"10px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Text
                        textAlign={"center"}
                        p={"10px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet3} <br />
                        {item.time1}
                      </Text>
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet4} <br />
                        {item.time2}
                      </Text>
                    </Box>
                  ) : (
                    <Box h="100px" w="100%"></Box>
                  )}
                </Box>
              </Stack>
              {/* fri line */}
              <Stack flexDir={"row"} bg={"#fff"} borderRadius="5px" my="10px">
                <Box
                  className="title"
                  w="33%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text
                    textAlign={"center"}
                    color="rgba(0, 0, 0, 1)"
                    fontSize="14px"
                    fontWeight={"500"}
                    fontFamily={"'Roboto', sans-serif"}
                    w="100%"
                    textTransform={"capitalize"}
                  >
                    sat
                  </Text>
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.sat === true ? (
                    <Box
                      bg={item.bgColor2 === "" ? item.bgColor : item.bgColor2}
                      w="100%"
                      h="100px"
                      borderRadius={"10px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet1} <br />
                        {item.time1}
                      </Text>
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet2} <br />
                        {item.time2}
                      </Text>
                    </Box>
                  ) : (
                    <Box h="100px" w="100%"></Box>
                  )}
                </Box>
                <Box
                  className="title"
                  w="33%"
                  textAlign={"center"}
                  borderRight="1px solid rgba(216, 216, 255, 1)"
                  borderLeft="1px solid rgba(216, 216, 255, 1)"
                  h="auto"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {item.sat2 === true ? (
                    <Box
                      bg={item.bgColor4 === "" ? item.bgColor3 : item.bgColor4}
                      w="100%"
                      h="100px"
                      borderRadius={"10px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Text
                        textAlign={"center"}
                        p={"10px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet3} <br />
                        {item.time1}
                      </Text>
                      <Text
                        textAlign={"center"}
                        p={"2px"}
                        color={"#fff"}
                        fontFamily="'Roboto',sans-serif"
                        fontWeight="400"
                        fontSize="12px"
                        w="100%"
                      >
                        {item.timeSet4} <br />
                        {item.time2}
                      </Text>
                    </Box>
                  ) : (
                    <Box h="100px" w="100%"></Box>
                  )}
                </Box>
              </Stack>
            </Stack>
          ))}
        </Slider>
      </Stack>
    </VStack>
  );
};

export default Calender;

// <Box
// className="day"
// w="11.42%"
// display="flex"
// alignItems="center"
// justifyContent="center"
// p="0"
// m="0"
// gap="0"
// h="114px"
// borderRight="1px solid rgba(216, 216, 255, 1)"
// >

// </Box>
// <Box
// className="day"
// w="11.42%"
// display="flex"
// alignItems="center"
// justifyContent="center"
// borderRight="1px solid rgba(216, 216, 255, 1)"
// h="114px"
// >
// {item.mon === true ? (
//   <Box
//     bg={item.bgColor2 === "" ? item.bgColor : item.bgColor2}
//     w="100%"
//     h="114px"
//     borderRadius={"10px"}
//     display="flex"
//     alignItems="center"
//     justifyContent="center"
//     flexDirection="column"
//   >
//     <Text textAlign={"center"} p={"2px"} color={"#fff"}>
//       {item.timeSet1}
//     </Text>
//     <Text textAlign={"center"} p={"2px"} color={"#fff"}>
//       {item.timeSet2}
//     </Text>
//   </Box>
// ) : (
//   ""
// )}
// </Box>
// <Box
// className="day"
// w="11.42%"
// display="flex"
// alignItems="center"
// justifyContent="center"
// borderRight="1px solid rgba(216, 216, 255, 1)"
// h="114px"
// >
// {item.tue === true ? (
//   <Box
//     bg={item.bgColor2 === "" ? item.bgColor : item.bgColor2}
//     w="100%"
//     h="114px"
//     borderRadius={"10px"}
//     display="flex"
//     alignItems="center"
//     justifyContent="center"
//     flexDirection="column"
//   >
//     <Text textAlign={"center"} p={"2px"} color={"#fff"}>
//       {item.timeSet1}
//     </Text>
//     <Text textAlign={"center"} p={"2px"} color={"#fff"}>
//       {item.timeSet2}
//     </Text>
//   </Box>
// ) : (
//   ""
// )}
// </Box>
// <Box
// className="day"
// w="11.42%"
// display="flex"
// alignItems="center"
// justifyContent="center"
// borderRight="1px solid rgba(216, 216, 255, 1)"
// h="114px"
// >
// {item.wed === true ? (
//   <Box
//     bg={item.bgColor2 === "" ? item.bgColor : item.bgColor2}
//     w="100%"
//     h="114px"
//     borderRadius={"10px"}
//     display="flex"
//     alignItems="center"
//     justifyContent="center"
//     flexDirection="column"
//   >
//     <Text textAlign={"center"} p={"2px"} color={"#fff"}>
//       {item.timeSet1}
//     </Text>
//     <Text textAlign={"center"} p={"2px"} color={"#fff"}>
//       {item.timeSet2}
//     </Text>
//   </Box>
// ) : (
//   ""
// )}
// </Box>
// <Box
// className="day"
// w="11.42%"
// display="flex"
// alignItems="center"
// justifyContent="center"
// borderRight="1px solid rgba(216, 216, 255, 1)"
// h="114px"
// >
// {item.thu === true ? (
//   <Box
//     bg="rgba(96, 31, 235, 1)"
//     w="100%"
//     h="114px"
//     borderRadius={"10px"}
//     display="flex"
//     alignItems="center"
//     justifyContent="center"
//     flexDirection="column"
//   >
//     <Text textAlign={"center"} p={"2px"} color={"#fff"}>
//       {item.timeSet1}
//     </Text>
//     <Text textAlign={"center"} p={"2px"} color={"#fff"}>
//       {item.timeSet2}
//     </Text>
//   </Box>
// ) : (
//   ""
// )}
// </Box>
// <Box
// className="day"
// w="11.42%"
// display="flex"
// alignItems="center"
// justifyContent="center"
// borderRight="1px solid rgba(216, 216, 255, 1)"
// h="114px"
// >
// {item.fri === true ? (
//   <Box
//     bg="rgba(96, 31, 235, 1)"
//     w="100%"
//     h="114px"
//     borderRadius={"10px"}
//     display="flex"
//     alignItems="center"
//     justifyContent="center"
//     flexDirection="column"
//   >
//     <Text textAlign={"center"} p={"2px"} color={"#fff"}>
//       {item.timeSet1}
//     </Text>
//     <Text textAlign={"center"} p={"2px"} color={"#fff"}>
//       {item.timeSet2}
//     </Text>
//   </Box>
// ) : (
//   ""
// )}
// </Box>
// <Box
// className="day"
// w="11.42%"
// display="flex"
// alignItems="center"
// justifyContent="center"
// borderRight="1px solid rgba(216, 216, 255, 1)"
// h="114px"
// >
// {item.sat === true ? (
//   <Box
//     bg="rgba(96, 31, 235, 1)"
//     w="100%"
//     h="114px"
//     borderRadius={"10px"}
//     display="flex"
//     alignItems="center"
//     justifyContent="center"
//     flexDirection="column"
//   >
//     <Text textAlign={"center"} p={"2px"} color={"#fff"}>
//       {item.timeSet1}
//     </Text>
//     <Text textAlign={"center"} p={"2px"} color={"#fff"}>
//       {item.timeSet2}
//     </Text>
//   </Box>
// ) : (
//   ""
// )}
// </Box>
